/** Driving-speed overlay freeze. Thresholds match Niantic-scale passenger warning, not jogging. */

export const LOCK_MPS = 8.33
export const RELEASE_MPS = 6.94

export const SPEED_WARN =
  "You're going too fast. This AR view should not be used while driving."

export function nextSpeedLocked(speedMps, locked) {
  if (!Number.isFinite(speedMps)) return Boolean(locked)
  if (locked) return speedMps >= RELEASE_MPS
  return speedMps >= LOCK_MPS
}
